export default "__VITE_ASSET__CGElycLf__"